import {
  CREATE_CHARGER,
  CREATE_CHARGER_FAIL,
  CREATE_CHARGER_SUCCESS,
  FETCH_CHARGER,
  FETCH_CHARGER_SUCCESS,
  FETCH_CHARGER_FAIL,
  GET_CHARGER,
  GET_CHARGER_SUCCESS,
  GET_CHARGER_FAIL,
  DELETE_CHARGER_SUCCESS,
  DELETE_CHARGER_FAIL,
  FETCH_CHARGER_BY_STATION,
  FETCH_CHARGER_BY_STATION_SUCCESS,
  FETCH_CHARGER_BY_STATION_FAIL,
  UPDATE_CHARGER,
  UPDATE_CHARGER_SUCCESS,
  UPDATE_CHARGER_FAIL,
  CHANGE_CHARGER_STATUS,
  CHANGE_CHARGER_STATUS_SUCCESS,
  CHANGE_CHARGER_STATUS_FAIL,
  CHANGE_CHARGER_IS_ACTIVE_STATUS,
  CHANGE_CHARGER_IS_ACTIVE_STATUS_SUCCESS,
  CHANGE_CHARGER_IS_ACTIVE_STATUS_FAIL,
  FETCH_CHARGERS_LIST,
  FETCH_CHARGERS_LIST_FAIL,
  FETCH_CHARGERS_LIST_SUCCESS,
} from 'actions/charger';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: true,
  chargers: [],
  stationChargers: [],
  chargerDetails: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const chargerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CHARGER:
    case CREATE_CHARGER:
    case GET_CHARGER:
    case FETCH_CHARGER_BY_STATION:
    case UPDATE_CHARGER:
    case CHANGE_CHARGER_STATUS:
    case CHANGE_CHARGER_IS_ACTIVE_STATUS:
    case FETCH_CHARGERS_LIST: {
      return { ...state, isLoading: true };
    }
    case FETCH_CHARGER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        chargers: payload,
      };
    }
    case FETCH_CHARGER_BY_STATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        stationChargers: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }
    case GET_CHARGER_SUCCESS: {
      return {
        ...state,
        chargerDetails: payload,
        isLoading: false,
      };
    }
    case CREATE_CHARGER_SUCCESS: {
      toast.success('Charger added successfully');
      if (_.get(payload, 'charging_station.id', '')) {
        const stationId = payload.charging_station.id;
        window.location.href = `/stations/${stationId}`;
      } else {
        window.location.href = '/chargerStatus';
      }

      return {
        ...state,
        chargers: _.concat(state.chargers, payload),
        isLoading: false,
      };
    }
    case DELETE_CHARGER_SUCCESS: {
      toast.success('Charger deleted successfully');
      setTimeout(() => {
        window.location.href = '/chargerStatus';
      }, 1000);
      return {
        ...state,
        chargers: state.chargers.filter((data) => data.id !== payload),
      };
    }
    case UPDATE_CHARGER_SUCCESS: {
      toast.success('Charger updated successfully');
      setTimeout(() => {
        const chargerId = payload.id;
        window.location.href = `/charger/${chargerId}`;
      }, 1000);
      return {
        ...state,
        chargers: state.chargers.map((data) => (data.id === payload.id ? payload : data)),
      };
    }
    case CHANGE_CHARGER_STATUS_SUCCESS: {
      // toast.success('Charger status changed successfully', payload);
      toast.success(`Charger is ${payload.is_enabled === true ? 'Enabled' : 'Disabled'} successfully`, payload);
      return {
        ...state,
        chargerDetails: payload,
      };
    }
    case CHANGE_CHARGER_IS_ACTIVE_STATUS_SUCCESS: {
      toast.success(`Charger Published successfully`);
      return {
        ...state,
        chargerDetails: payload,
      };
    }

    case FETCH_CHARGERS_LIST_SUCCESS: {
      return {
        ...state,
        chargersList: payload.results,
        isLoading: false,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_CHARGER_FAIL:
    case GET_CHARGER_FAIL:
    case CREATE_CHARGER_FAIL:
    case DELETE_CHARGER_FAIL:
    case FETCH_CHARGER_BY_STATION_FAIL:
    case UPDATE_CHARGER_FAIL:
    case CHANGE_CHARGER_STATUS_FAIL:
    case CHANGE_CHARGER_IS_ACTIVE_STATUS_FAIL:
    case FETCH_CHARGERS_LIST_FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default chargerReducer;
